import { render, staticRenderFns } from "./PartnerRepAprModel.vue?vue&type=template&id=bc5f9e42&scoped=true"
import script from "./PartnerRepAprModel.vue?vue&type=script&lang=ts"
export * from "./PartnerRepAprModel.vue?vue&type=script&lang=ts"
import style0 from "./PartnerRepAprModel.vue?vue&type=style&index=0&id=bc5f9e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f9e42",
  null
  
)

export default component.exports